// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/.pnpm/@umijs+react-refresh-webpack-plugin@0.5.11_@types+webpack@5.28.5_react-refresh@0.14.0_type-fest@1.4.0_webpack@5.104.1/node_modules/@umijs/react-refresh-webpack-plugin/client/ReactRefreshEntry.js");
var __webpack_exports__ = __webpack_require__("./mfsu-virtual-entry/umi.js");
